module.exports = __webpack_public_path__ + "img/2020051115493020200511154115.62b913b2.png";